<template>
    <div id="contenedor-nueva-minuta">
        <v-form v-model="formularioValido" ref="registraNuevaMinuta">
          <v-card flat>
            <v-card-title class="secondary--text">
            Registrar nueva Minuta
            <v-spacer></v-spacer>
            <v-btn icon @click="cerrar">
                <v-icon class="secondary--text" large>highlight_off</v-icon>
            </v-btn>
            </v-card-title>
            <v-divider class="mx-2"></v-divider>
            <v-card-text>
              <v-row dense class="" style="">
                <custom-text-field
                cols="6"
                v-model="minuta.numero"
                label="Número"
                :rules="[mixReglas.requerido]"
                >
                </custom-text-field>
              </v-row>
              <v-row dense class="" style="">
                <v-col cols="12" md="6" class="">
                  <custom-date-picker
                  v-model="minutaFecha"
                  label="Fecha"
                  :rules="[mixReglas.requerido]">
                  </custom-date-picker>
                </v-col>
                <v-col cols="12" md="6">
                  <custom-select
                  v-model="minutaHora"
                  label="Hora"
                  :items="horas"
                  :rules="[mixReglas.requerido]">
                  </custom-select>
                </v-col>
              </v-row>
              <custom-text-field
                cols="12"
                class=""
                v-model="minuta.lugar"
                label="Lugar"
                :rules="[mixReglas.requerido]"
                >
              </custom-text-field>
              <custom-text-area
                cols="12"
                v-model="minuta.objetivo"
                label="Objetivo"
                rows="3"
                :rules="[mixReglas.requerido]">
              </custom-text-area>
            </v-card-text>
            <v-divider class="bkground" />
            <v-card-actions>
                <v-spacer></v-spacer>
                <custom-button
                    @click="cerrar"
                    tipo="formCancelar"
                    label="Cancelar"
                    class="mr-3">
                </custom-button>
                <custom-button
                    @click="guardar"
                    tipo="formAceptar"
                    label="Guardar"
                    :disabled="!formularioValido ||
                    enviandoFormulario "
                    :loading="enviandoFormulario"
                    >
                </custom-button>
            </v-card-actions>
          </v-card>
        </v-form>

    </div>
</template>
<script>
import CustomButton from '@/components/buttons/Button.vue';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import CustomTextArea from '@/components/inputs/TextArea.vue';
import mixMinutas from './mixMinutas';

export default {
  name: 'NuevaMinuta',
  mixins: [mixMinutas],
  props: {
    idContrato: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      horas: this.getHorasList(),
      minutaFecha: '',
      minutaHora: '',
      minuta: {
        idContrato: this.idContrato,
        numero: '',
        fechaHora: '',
        lugar: '',
        objetivo: '',
      },
    };
  },
  components: {
    CustomButton,
    CustomDatePicker,
    CustomTextArea,
    CustomTextField,
    CustomSelect,
  },
  methods: {
    limpiarFormulario() {
      this.$refs.registraNuevaMinuta.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    getFechaHora() {
      const fechaHora = `${this.minutaFecha} ${this.minutaHora}:00.999+0000`;
      return fechaHora;
    },
    getHorasList() {
      const horas = [];
      const horaInicio = 7;
      const horaFin = 19;
      for (let hora = horaInicio; hora <= horaFin; hora += 1) {
        horas.push(`${hora.toString().padStart(2, '0')}:00`);
        if (hora !== horaFin) {
          horas.push(`${hora.toString().padStart(2, '0')}:30`);
        }
      }
      return horas;
    },
    async guardar() {
      this.minuta.fechaHora = this.getFechaHora();
      await this.mixAgregarMinuta();
    },
  },
};
</script>
